import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import * as PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { history } from "../../redux/store/configureStore";
import TeachersList from "./TeachersList";
import * as teacherActions from "../../redux/actions/teacherActions";
import {
  buildManageRouteWithSchoolYear,
  getNormalizedSchoolYearStartYearFromSearch,
} from "./manageSchoolYearRouting";

const isActiveTeacher = teacher => teacher.archived !== true && teacher.deleted !== true;
const isArchivedTeacher = teacher => teacher.archived === true && teacher.deleted !== true;

export function Teachers({ teachers, loadTeachers }) {
  const location = useLocation();
  const activeSchoolYearStartYear = getNormalizedSchoolYearStartYearFromSearch(location.search);
  const [showArchivedTeachers, setShowArchivedTeachers] = useState(false);

  useEffect(() => {
    if (teachers.length === 0) {
      loadTeachers()
        .catch((error) => {
          alert(`Loading teachers failed ${error}`);
        });
    }
  }, []);


  const handleEdit = (teacher) => {
    history.push(buildManageRouteWithSchoolYear(`/manage/teacher/${teacher.id}`, location.search, activeSchoolYearStartYear));
  };

  const handleAdd = () => {
    history.push(buildManageRouteWithSchoolYear("/manage/teacher/new", location.search, activeSchoolYearStartYear));
  };

  const handleShowArchivedTeachers = () => {
    setShowArchivedTeachers(!showArchivedTeachers);
  };

  const filteredTeachers = showArchivedTeachers
    ? teachers.filter(isArchivedTeacher)
    : teachers.filter(isActiveTeacher);

  return (
    <div className="mb-5">
      <TeachersList
        teachers={filteredTeachers}
        onAdd={handleAdd}
        onEdit={handleEdit}
        showArchivedTeachers={showArchivedTeachers}
        onShowArchivedTeachers={handleShowArchivedTeachers}
      />
    </div>
  );
}

Teachers.propTypes = {
  teachers: PropTypes.array.isRequired,
  loadTeachers: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  teachers: state.teachers,
});

const mapDispatchToProps = dispatch => ({
  loadTeachers: () => dispatch(teacherActions.loadTeachers()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Teachers);
